export const findCurrentSavingsObj = (savingsInfoArr, indx, savingsArr, savingsType, currentGameDate) => {
    let svgIndx = null;
    savingsInfoArr[indx].createNewElementSw = true;
    svgIndx = savingsArr.findIndex(elem => elem.savingsType + elem.closedDate === 
            savingsType + "");
    if (svgIndx !== -1 && savingsArr[svgIndx].closedDate === ""){
        savingsInfoArr[indx].createNewElementSw = false;
        savingsInfoArr[indx].svgIndx = svgIndx;
    }
}

export default findCurrentSavingsObj;
